import { render, staticRenderFns } from "./EvidenceUpload.vue?vue&type=template&id=a04c37bc&scoped=true"
import script from "./EvidenceUpload.vue?vue&type=script&lang=ts"
export * from "./EvidenceUpload.vue?vue&type=script&lang=ts"
import style0 from "./EvidenceUpload.vue?vue&type=style&index=0&id=a04c37bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a04c37bc",
  null
  
)

export default component.exports